(function () {
  'use strict';

  if (!window.fetch || window.__ovoinPerformanceOptimized) return;
  window.__ovoinPerformanceOptimized = true;

  var nativeFetch = window.fetch.bind(window);
  var isMobile = !!(window.matchMedia && window.matchMedia('(max-width: 767px)').matches);
  var miniCartQueue = [];
  var recommendationsQueue = [];
  var loginQueue = [];
  var popupsQueue = [];
  var quickViewQueue = [];
  var miniCartReleased = false;
  var recommendationsReleased = false;
  var loginReleased = false;
  var popupsReleased = false;
  var quickViewReleased = !isMobile;
  var cartTriggerSelector = '[data-drawer-options*="#t4s-mini_cart"]';
  var loginTriggerSelector = '[data-drawer-options*="#t4s-login-sidebar"]';
  var addToCartSelector = '[data-atc-form], [data-action-atc], form[action*="/cart/add"]';
  var quickViewTriggerSelector = '[data-action-quickview]';

  function disableMobileSecondaryImages(root) {
    if (!isMobile || !root) return;

    var products = [];
    if (root.nodeType === 1 && root.matches && root.matches('[data-product-options]')) {
      products.push(root);
    }
    if (root.querySelectorAll) {
      products = products.concat(Array.prototype.slice.call(root.querySelectorAll('[data-product-options]')));
    }

    products.forEach(function (product) {
      var rawOptions = product.getAttribute('data-product-options');
      if (!rawOptions || rawOptions.indexOf('"image2"') === -1) return;

      try {
        var options = JSON.parse(rawOptions);
        if (!options.image2) return;
        options.image2 = false;
        delete options.alt;
        product.setAttribute('data-product-options', JSON.stringify(options));
      } catch (error) {
        // Leave malformed third-party product data untouched.
      }
    });
  }

  function removeMobileProductCardActions(root) {
    if (!isMobile || !root) return;

    var selector = '.t4s-pr-grid .t4s-product-inner > .t4s-product-btns';
    var actionGroups = [];
    if (root.nodeType === 1 && root.matches && root.matches(selector)) {
      actionGroups.push(root);
    }
    if (root.querySelectorAll) {
      actionGroups = actionGroups.concat(Array.prototype.slice.call(root.querySelectorAll(selector)));
    }

    actionGroups.forEach(function (actionGroup) {
      actionGroup.remove();
    });
  }

  function applyVariantImageSwatchFallback(root) {
    if (!root || !root.querySelectorAll || !window.getComputedStyle) return;

    var selector = '[data-color-options]';
    var containers = [];
    if (root.nodeType === 1 && root.matches && root.matches(selector)) {
      containers.push(root);
    }
    if (root.nodeType === 1 && root.closest) {
      var parentContainer = root.closest(selector);
      if (parentContainer) containers.push(parentContainer);
    }
    containers = containers.concat(Array.prototype.slice.call(root.querySelectorAll(selector)));

    containers.filter(function (container, index, list) {
      return list.indexOf(container) === index;
    }).forEach(function (container) {
      var rawOptions = container.getAttribute('data-color-options');
      if (!rawOptions) return;

      var options;
      try {
        options = JSON.parse(rawOptions);
      } catch (error) {
        return;
      }

      var imageOptions = options.img_options || [];
      var variantImages = options.img_variants || [];

      Array.prototype.forEach.call(
        container.querySelectorAll('.t4s-pr-color__item:not(.is--colors-more)'),
        function (item) {
          var value = item.querySelector('.t4s-pr-color__value');
          var nameNode = item.querySelector('.t4s-pr-color__name');
          if (!value || !nameNode || !nameNode.textContent.trim()) return;

          var style = window.getComputedStyle(value);
          var backgroundColor = style.backgroundColor.replace(/\s+/g, '');
          var hasColor = backgroundColor !== 'transparent' &&
            backgroundColor !== 'rgba(0,0,0,0)';
          var hasImage = style.backgroundImage && style.backgroundImage !== 'none';
          if (hasColor || hasImage) return;

          var imageIndex = imageOptions.indexOf(nameNode.textContent.trim());
          var imageUrl = imageIndex > -1 ? variantImages[imageIndex] : null;
          if (!imageUrl || typeof imageUrl !== 'string') return;

          imageUrl += imageUrl.indexOf('?') > -1 ? '&width=80' : '?width=80';
          value.style.backgroundImage = 'url("' + imageUrl.replace(/"/g, '\\"') + '")';
          value.classList.add('ovoin-variant-image-fallback');
        }
      );
    });
  }

  function disableProductCardSwatchImageChange() {
    var productItem = window.T4SThemeSP && window.T4SThemeSP.ProductItem;
    var themeJquery = window.jQuery_T4NT;
    if (!productItem || typeof productItem.swatchesClickHover !== 'function' || !themeJquery) {
      return false;
    }

    var swatchSelector = '.t4s-pr-color__item:not(.is-swatch--current):not([data-img="none"]):not(.is--colors-more)';
    var $document = themeJquery(document);
    $document.off('mouseenter.hoverIntent', swatchSelector);
    $document.off('mouseleave.hoverIntent', swatchSelector);
    $document.off('click', swatchSelector);
    productItem.swatchesClickHover = function () {};
    return true;
  }

  var swatchDisableAttempts = 0;
  var swatchDisableTimer = window.setInterval(function () {
    swatchDisableAttempts += 1;
    if (disableProductCardSwatchImageChange() || swatchDisableAttempts >= 200) {
      window.clearInterval(swatchDisableTimer);
    }
  }, 50);

  disableMobileSecondaryImages(document);
  removeMobileProductCardActions(document);
  applyVariantImageSwatchFallback(document);

  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          applyVariantImageSwatchFallback(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (isMobile && window.MutationObserver) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          disableMobileSecondaryImages(node);
          removeMobileProductCardActions(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  function getRequestUrl(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function parseUrl(input) {
    try {
      return new URL(getRequestUrl(input), window.location.href);
    } catch (error) {
      return null;
    }
  }

  function isMiniCartRequest(url) {
    return url &&
      url.origin === window.location.origin &&
      url.searchParams.get('section_id') === 'mini_cart';
  }

  function isMiniCartRecommendationsRequest(url) {
    return url &&
      url.origin === window.location.origin &&
      url.searchParams.get('section_id') === 'mini_cart_upsell';
  }

  function isLoginRequest(url) {
    return url &&
      url.origin === window.location.origin &&
      url.searchParams.get('section_id') === 'login-sidebar';
  }

  function isPopupsRequest(url) {
    return url &&
      url.origin === window.location.origin &&
      url.searchParams.get('section_id') === 'popups';
  }

  function isQuickViewRequest(url) {
    return url &&
      url.origin === window.location.origin &&
      url.searchParams.get('section_id') === 'main-qv';
  }

  function queueRequest(queue, input, init) {
    return new Promise(function (resolve, reject) {
      queue.push({ input: input, init: init, resolve: resolve, reject: reject });
    });
  }

  function flushQueue(queue) {
    queue.splice(0).forEach(function (request) {
      nativeFetch(request.input, request.init).then(request.resolve, request.reject);
    });
  }

  function releaseMiniCart() {
    if (miniCartReleased) return;
    miniCartReleased = true;
    flushQueue(miniCartQueue);
  }

  function releaseRecommendations() {
    if (recommendationsReleased) return;
    recommendationsReleased = true;
    flushQueue(recommendationsQueue);
  }

  function releaseLogin() {
    if (loginReleased) return;
    loginReleased = true;
    flushQueue(loginQueue);
  }

  function releasePopups() {
    if (popupsReleased) return;
    popupsReleased = true;
    flushQueue(popupsQueue);
  }

  function releaseQuickView() {
    if (quickViewReleased) return;
    quickViewReleased = true;
    flushQueue(quickViewQueue);
  }

  window.fetch = function (input, init) {
    var url = parseUrl(input);

    if (isMiniCartRequest(url) && !miniCartReleased) {
      return queueRequest(miniCartQueue, input, init);
    }

    if (isMiniCartRecommendationsRequest(url) && !recommendationsReleased) {
      return queueRequest(recommendationsQueue, input, init);
    }

    if (isLoginRequest(url) && !loginReleased) {
      return queueRequest(loginQueue, input, init);
    }

    if (isPopupsRequest(url) && !popupsReleased) {
      return queueRequest(popupsQueue, input, init);
    }

    if (isQuickViewRequest(url) && !quickViewReleased) {
      return queueRequest(quickViewQueue, input, init);
    }

    return nativeFetch(input, init);
  };

  function closestTarget(event, selector) {
    return event.target && event.target.closest ? event.target.closest(selector) : null;
  }

  function warmMiniCart(event) {
    if (closestTarget(event, cartTriggerSelector) || closestTarget(event, addToCartSelector)) {
      releaseMiniCart();
    }
    if (closestTarget(event, loginTriggerSelector)) {
      releaseLogin();
    }
  }

  document.addEventListener('pointerover', warmMiniCart, true);
  document.addEventListener('touchstart', warmMiniCart, { capture: true, passive: true });
  document.addEventListener('focusin', warmMiniCart, true);
  document.addEventListener('submit', warmMiniCart, true);
  document.addEventListener('pointerdown', function (event) {
    if (closestTarget(event, quickViewTriggerSelector)) releaseQuickView();
  }, true);
  document.addEventListener('touchstart', function (event) {
    if (closestTarget(event, quickViewTriggerSelector)) releaseQuickView();
  }, { capture: true, passive: true });
  document.addEventListener('click', function (event) {
    if (closestTarget(event, quickViewTriggerSelector)) releaseQuickView();
    if (!closestTarget(event, cartTriggerSelector)) return;
    releaseMiniCart();
    releaseRecommendations();
  }, true);

  function watchCartDrawer() {
    var drawer = document.getElementById('t4s-mini_cart');
    if (!drawer || !window.MutationObserver) return;

    function checkDrawer() {
      if (drawer.getAttribute('aria-hidden') === 'false') {
        releaseRecommendations();
      }
    }

    new MutationObserver(checkDrawer).observe(drawer, {
      attributes: true,
      attributeFilter: ['aria-hidden', 'class']
    });
    checkDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchCartDrawer, { once: true });
  } else {
    watchCartDrawer();
  }

  window.setTimeout(function () {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(releaseMiniCart, { timeout: 2000 });
    } else {
      releaseMiniCart();
    }
  }, 3000);

  window.setTimeout(function () {
    var releaseSecondaryContent = function () {
      releaseLogin();
      releasePopups();
    };
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(releaseSecondaryContent, { timeout: 2000 });
    } else {
      releaseSecondaryContent();
    }
  }, 5000);
}());
